// extracted by mini-css-extract-plugin
export default {"cardWrapper":"CommonErrorBoundary_cardWrapper__vxfRz","background":"CommonErrorBoundary_background__LMa-X"};